// Tiny module-level bus so `openDocument` (a plain function called from onClick
// handlers) can trigger the in-app xlsx viewer, which is a React component
// mounted once in OperationsLayout. Avoids threading modal state through every
// "Ver" button.
import { useSyncExternalStore } from 'react'

export type XlsxPreviewDoc = { id: string; filename: string }

let current: XlsxPreviewDoc | null = null
const listeners = new Set<() => void>()

export function isSpreadsheetName(name?: string | null): boolean {
  return !!name && /\.(xlsx|xls)$/i.test(name)
}

export function openXlsxPreview(doc: XlsxPreviewDoc): void {
  current = doc
  listeners.forEach((l) => l())
}

export function closeXlsxPreview(): void {
  current = null
  listeners.forEach((l) => l())
}

// Subscribe to the current preview target (null = closed). Used by the modal.
export function useXlsxPreviewDoc(): XlsxPreviewDoc | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb)
      return () => listeners.delete(cb)
    },
    () => current,
    () => current,
  )
}
